module.exports = __webpack_public_path__ + "static/media/icon_schedule_phone_white.279fc26f.svg";